/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardGrant
 */
export interface RewardGrant {
    /**
     * The reward catalog item this grant references — the template supplying presentation, type and fulfillment.
     * @type {string}
     * @memberof RewardGrant
     */
    catalogItemId: string;
    /**
     * The quantity for this use. Omitted for VARIABLE-unit items (payout sets it).
     * @type {number}
     * @memberof RewardGrant
     */
    amount?: number;
    /**
     * Gift-card face value in USD for this use (the Tillo brand is on the item).
     * @type {number}
     * @memberof RewardGrant
     */
    giftCardAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardGrant
     */
    durationAmount?: number;
    /**
     * Per-use scope — the campaign ledger a points grant credits.
     * @type {string}
     * @memberof RewardGrant
     */
    campaignId?: string;
    /**
     * Per-use scope — the surface a surface-points grant lands on.
     * @type {string}
     * @memberof RewardGrant
     */
    surfaceId?: string;
    /**
     * When true the grant pays automatically on completion; when false/absent the user claims it. Grant-level because the same item can be auto in one placement and claimable in another.
     * @type {boolean}
     * @memberof RewardGrant
     */
    autoClaim?: boolean;
}

/**
 * Check if a given object implements the RewardGrant interface.
 */
export function instanceOfRewardGrant(value: object): value is RewardGrant {
    if (!('catalogItemId' in value) || value['catalogItemId'] === undefined) return false;
    return true;
}

export function RewardGrantFromJSON(json: any): RewardGrant {
    return RewardGrantFromJSONTyped(json, false);
}

export function RewardGrantFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardGrant {
    if (json == null) {
        return json;
    }
    return {
        
        'catalogItemId': json['catalogItemId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
        'durationAmount': json['durationAmount'] == null ? undefined : json['durationAmount'],
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'autoClaim': json['autoClaim'] == null ? undefined : json['autoClaim'],
    };
}

export function RewardGrantToJSON(json: any): RewardGrant {
    return RewardGrantToJSONTyped(json, false);
}

export function RewardGrantToJSONTyped(value?: RewardGrant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catalogItemId': value['catalogItemId'],
        'amount': value['amount'],
        'giftCardAmount': value['giftCardAmount'],
        'durationAmount': value['durationAmount'],
        'campaignId': value['campaignId'],
        'surfaceId': value['surfaceId'],
        'autoClaim': value['autoClaim'],
    };
}

